import MobileNav from "./MobileNav";
import Profile from "./Profile";
import Create from "./Create";
import Notifications from "./Notifications";

export default { MobileNav, Profile, Create, Notifications };
